// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2hAds","rightAdornment":"Header_rightAdornment__3EHGq"};